import React from 'react'
import underTitle from '../../../assets/media/home/underTitle.png'

const PageHeader = ({ titleText, customStyleText, customStyleImage, customStyleContainer }) => {
  return (
    <div className={`pageHeader ${customStyleContainer} px-4`}>
      <h2 className={`text-2xl text-[#333333] text-center font-semibold lg:text-[36px] lg:font-[600] 2xl:text-[48px] 2xl:font-[700] 2xl:leading-[63px] lg:leading-[50px] ${customStyleText}`}>{titleText}</h2>
      <div className="underTitle flex justify-center">
        <img src={underTitle} className={`w-52 mt-[15px] object-contain 2xl:w-[464px] 2xl:mt-[15px] ${customStyleImage}`} alt="" />
      </div>
    </div>
  )
}

export default PageHeader